module.exports = __webpack_public_path__ + "static/media/bg-mesa-ampliado.b28505e3.webp";